import { useMemo } from "react";
import { useLocale, useTranslations } from "next-intl";

import { BILLING_COUNTRY_CODES } from "@/lib/billingAddress";

/**
 * Pays des formulaires de facturation, triés dans la langue du visiteur.
 *
 * Les listes écrites à la main suivaient l'ordre alphabétique français, même
 * en anglais : « United States » tombait entre le Vatican et l'Éthiopie. Le
 * tri par Intl.Collator range aussi les accents à leur place (« Égypte » à E).
 *
 * @returns {{code: string, label: string}[]}
 */
export default function useCountryOptions() {
    const t = useTranslations();
    const locale = useLocale();

    return useMemo(() => {
        const collator = new Intl.Collator(locale, { sensitivity: "base" });
        return BILLING_COUNTRY_CODES.map((code) => ({
            code,
            label: t(`address_selectedCountry_${code}`),
        })).sort((a, b) => collator.compare(a.label, b.label));
    }, [t, locale]);
}
